import React, { Component } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import { Link, Redirect } from "react-router-dom";

// use babel-import-plugin as specified in Ant Design Docs!
// https://ant.design/docs/react/getting-started#Import-on-Demand
import Popover from 'antd/lib/popover';
import Icon from 'antd/lib/icon';
import 'antd/lib/popover/style/css';
import 'antd/lib/icon/style/css';
import menu from "../../img/menu.png"

import { Parse } from "parse";

//import './styles.css';

class ResponsiveNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      menuVisible: false,
      redirect: false,
    };
  }


  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener('resize', this.saveViewportDimensions);
    var user = Parse.User.current();
    //if no user, disconnect and redirect to homepage
    if (user === null) {
      this.props.handleDisconnect();
      this.setState({ redirect: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.saveViewportDimensions);
  }

  chooseTeam = (user) => {
    if (user === undefined || user === null) {
      return "";
    }
    if (!user.attributes.professional) {
      return (
        <Link to="/team">
          <Icon type="team" />
          Mon équipe
        </Link>
      );
    } else
      return (
        <Link to="/team">
          <Icon type="team" />
          Dossier
        </Link>
      );
  }

  chooseFidelite = (user) => {
    if (user === undefined || user === null) {
      return "";
    }
    if ("professional" in user.attributes) {
      if (user.attributes.professional === true) {

        return (
          <Link to="/fidelite">
            <Icon type="star" />
            Best Team
          </Link>
        )
      }
        else {
          return (
            <Link to="/fidelite">
              <Icon type="star" />
              Fidélité
            </Link>
          )
        }
      }

    return (
      <Link to="/fidelite">
        <Icon type="star" />
        Fidélité
      </Link>
    );
  }

  handleMenuVisibility = (menuVisible) => {
    this.setState({ menuVisible });
  };

  saveViewportDimensions = throttle(() => {
    this.setState({
      viewportWidth: window.innerWidth,
    })
  }, this.props.applyViewportChange);

  render() {
    var user = Parse.User.current();
    if (this.state.redirect === true) {
      return <Redirect to="/" />;
    }

    const MenuMarkup = this.props.menuMarkup;
    if (this.state.viewportWidth > this.props.mobileBreakPoint) {
      let userTab = this.chooseTeam(user);
      let fidelityTab = this.chooseFidelite(user);
      return <MenuMarkup activeLinkKey={this.props.activeLinkKey}  firstItem={userTab} secondItem={fidelityTab} />;
    }

    return (
      <Popover
        content={<MenuMarkup
          onLinkClick={() => this.handleMenuVisibility(false)}
          activeLinkKey={this.props.activeLinkKey}
          mobileVersion
          firstItem={this.chooseTeam(user)}
          secondItem={this.chooseFidelite(user)}
          className='to-override-mobile-menu-class'
          />
        }
        trigger='click'
        placement={this.props.placement}
        visible={this.state.menuVisible}
        onVisibleChange={this.handleMenuVisibility}
      >
        <img
          alt=""
          src={menu}
          style={{alignSelf: "flex-start", marginLeft: 25, marginTop: 10, height: 32, width: 32}}
        />
      </Popover>
    );
  }
}

ResponsiveNav.propTypes = {
  mobileBreakPoint: PropTypes.number,
  applyViewportChange: PropTypes.number,
  activeLinkKey: PropTypes.string,
  placement: PropTypes.string,
  menuMarkup: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
  ]),
};

ResponsiveNav.defaultProps = {
  mobileBreakPoint: 1000,
  applyViewportChange: 250,
  placement: 'bottom',
};

export default ResponsiveNav
